import { useTranslation } from 'react-i18next';

// Resolver for the bank account's ConnectionType, which the API returns as raw English ('manual' /
// 'online'). The raw value stays the logic key and only the rendered string is localized, so an
// unmapped value falls back to the raw string rather than rendering blank.
//
// Both i18n guards are structurally blind to this: capitalizing an API value is a function call, so
// there is no source literal for the literal guard and no t() call site for the key guard. The value
// is only visible in the browser — which is how ID-12680 shipped a French page whose every row was
// English under correctly-translated headings.
export default function useConnectionTypeLabels() {
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.ConnectionTypeItem' });

  function getConnectionTypeLabel(connectionType: string | undefined): string {
    if (!connectionType) return '';

    return t(connectionType, { defaultValue: connectionType });
  }

  return { getConnectionTypeLabel };
}
